import {DimensionItem} from '@selpia/shared/models';

export class DimensionFilterHelper {
  static getAsItemsWithDimensionName(filters: DimensionItem[]): Map<string, DimensionItem> {
    const filtersMapPerDimension: Map<string, DimensionItem> = new Map();
    filters.forEach(filter => {
      filtersMapPerDimension.set(filter.dimension.name, filter);
    });
    return filtersMapPerDimension;
  }
}
